import { Component, Input } from '@angular/core';

import { MatChipsModule } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-promotion-statut-chip',
  standalone: true,
  imports: [
    MatChipsModule,
    MatIcon
  ],
  templateUrl: './promotion-statut-chip.component.html',
  styleUrl: './promotion-statut-chip.component.scss'
})
export class PromotionStatutChipComponent {

  @Input() promotionStatut!: string;
  @Input() isDropDown = false;

  /**
   * Determines the appropriate chip color class based on the provided status.
   *
   * @param statut - The status of the promotion. Expected values are:
   *   - 'Non commencée': Returns 'to-start'
   *   - 'En Cours': Returns 'in-progress'
   *   - 'A valider': Returns 'pending'
   *   - 'Terminée': Returns 'validated'
   *   - Any other value: Returns an empty string
   * 
   * @returns The corresponding chip color class as a string.
   */
  manageChipColor(statut: any) {
    switch (statut) {
      case 'Non commencée':
        return 'to-start';
      case 'En Cours':
        return 'in-progress';
      case 'A valider':
        return 'pending';
      case 'Terminée':
        return 'validated';
      default:
        return '';
    }
  }

  /**
   * Determines the appropriate icon based on the given status.
   *
   * @param statut - The status of the promotion. Expected values are:
   *   - 'Non commencée': Returns 'error_outline'
   *   - 'En Cours': Returns 'refresh'
   *   - 'A valider': Returns 'alarm'
   *   - 'Terminée': Returns 'done'
   *   - Any other value: Returns an empty string
   * @returns The icon name corresponding to the given status.
   */
  manageChipIcon(statut: any) {
    switch (statut) {
      case 'Non commencée':
        return 'error_outline';
      case 'En Cours':
        return 'refresh';
      case 'A valider':
        return 'alarm';
      case 'Terminée':
        return 'done';
      default:
        return '';
    }
  }
}